const pieChartLabels = ['Postulante 1', 'Postulante 2', 'Postulante 3', 'Postulante 4', 'Postulante 5', 'Postulante 6', 'Postulante 7', 'Postulante 8'];
const pieChartData = [300, 500, 100, 50, 30, 10, 510, 800];
const pieChartType = 'pie';
const pieChartColors = {
  backgroundColor: ['#2fa7ff', '#7cdb86', '#805aff'],
  borderColor: ['#2fa7ff', '#7cdb86', '#805aff']
};
export default {
  data: {
    labels: pieChartLabels,
    type: pieChartType,
    datasets: [
      {
        data: pieChartData
      }
    ]
  }
};
